function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "31",
  height: "30",
  viewBox: "0 0 31 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 24h10v1H8v-1zm0-4v1h5v-1H8zm13 8H4V7h6.873c.561.318 1.212.5 1.906.5.695 0 1.346-.182 1.907-.5H20.5L23 5h-3.219V3.75h-3.183c0-2.07-1.709-3.75-3.818-3.75-2.108 0-3.818 1.68-3.818 3.75H5.781V5H2v25h21V17.5L21 20v8zM12.748 2.5a1.501 1.501 0 011.12 2.5h-2.237a1.499 1.499 0 011.117-2.5zM8 17h5v-1H8v1zM27.447 3.75l-2.852 2.817.005.005-8.766 8.663L14.603 20l4.766-1.279 8.762-8.66.004.005 2.852-2.818-3.54-3.498zm-8.489 13.704l-.17.046-1.665-1.65.046-.176L25.411 7.5l1.794 1.776-8.247 8.178zm7.407-10.91l1.136-1.127 1.805 1.791-1.136 1.125-1.805-1.789zM7 12H6v1h1v-1zM6 25h1v-1H6v1zm1-9H6v1h1v-1zm0 4H6v1h1v-1zm9-8H8v1h8v-1zm4-3H6v1h14V9z"
})));